"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlatformProofVerificationUnavailableError = void 0;
class PlatformProofVerificationUnavailableError extends Error {
    constructor(operation) {
        super(`${operation} requires an authenticated Platform proof verifier; `
            + 'configure platformProofVerifier or use the proof-verifying Wasm SDK');
        Object.setPrototypeOf(this, PlatformProofVerificationUnavailableError.prototype);
    }
}
exports.PlatformProofVerificationUnavailableError = PlatformProofVerificationUnavailableError;
exports.default = PlatformProofVerificationUnavailableError;
//# sourceMappingURL=PlatformProofVerificationUnavailableError.js.map